import styled from 'styled-components';
import { Box, Button, Text } from '@rsos/base-components';

export const HOVERED_COPY_BUTTON_WIDTH = 68;

export const HoveredButton = styled(Button).attrs(() => ({
  btnType: 'invisible',
  size: 'xsmall',
  noMargin: true,
  width: '60px',
  justify: 'space-evenly',
  align: 'center',
  height: 'inherit',
}))`
  color: ${p =>
    p.copied ? p.theme.colors.primaryBase : p.theme.colors.secondaryText};
`;

export const HoveredContainer = styled(Box).attrs(({ copied }) => ({
  bg: copied ? 'highlights' : 'foreground',

  display: copied ? 'flex' : 'none',
  height: 'inherit',
}))`
  border-radius: 5px;
  position: absolute;
  right: 0;
  top: ${props => props.top};
`;

export const ButtonText = styled(Text).attrs({
  pl: 2,
})``;
